export default "__VITE_ASSET__X38k9_SM__"